module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/insurance-health-67a8fb8b56b6d422ea27a0e6776f84e4.svg";